import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d5f01ed")

_pushScopeId("data-v-6d5f01ed")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = {
  key: 0,
  class: "cover-wrapper"
}
const _hoisted_3 = { class: "calendar-wrapper" }
const _hoisted_4 = { class: "flex flex-col h-full z-10 overflow-hidden" }
const _hoisted_5 = { class: "day-label" }
const _hoisted_6 = { class: "flex-grow overflow-y-auto overflow-x-auto" }
const _hoisted_7 = {
  key: 1,
  class: "detail-wrapper-bg"
}
const _hoisted_8 = { class: "detail-wrapper" }
const _hoisted_9 = { class: "detail-item" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_v_calendar = _resolveComponent("v-calendar")
  const _component_HotspotSwiper = _resolveComponent("HotspotSwiper")
  const _component_ImgContainer = _resolveComponent("ImgContainer")
  const _component_Back = _resolveComponent("Back")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (!_ctx.showDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_v_calendar, {
                  ref: "calendar",
                  class: "custom-calendar max-w-full",
                  masks: _ctx.masks,
                  attributes: _ctx.attributes,
                  "disable-page-swipe": "",
                  "is-expanded": "",
                  onTransitionStart: _ctx.calendarChange
                }, {
                  "day-content": _withId(({ day, attributes }) => [
                    _createVNode("div", _hoisted_4, [
                      _createVNode("span", _hoisted_5, _toDisplayString(day.day), 1),
                      _createVNode("div", _hoisted_6, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(attributes, (attr, index) => {
                          return (_openBlock(), _createBlock("p", {
                            key: index,
                            class: "text-xs",
                            onClick: _withModifiers(($event: any) => (_ctx.goActivity(attr.customData.data)), ["stop","prevent"])
                          }, _toDisplayString(attr.customData.title), 9, ["onClick"]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["masks", "attributes", "onTransitionStart"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_HotspotSwiper, {
                  list: _ctx.currentItem.main_img
                }, null, 8, ["list"]),
                _createVNode("div", _hoisted_9, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentItem.detail_img, (i, k) => {
                    return (_openBlock(), _createBlock(_component_ImgContainer, {
                      key: k,
                      src: i
                    }, null, 8, ["src"]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail)
          ? (_openBlock(), _createBlock(_component_Back, {
              key: 2,
              onAction: _ctx.goBack
            }, null, 8, ["onAction"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})